import { Box } from "@chakra-ui/react";
import Hero from "./component/Hero";
import Successstories from "./component/Successstories";
import WelcomeSection from "./component/WelcomeSection";
import Whatwedo from "./component/Whatwedo";
import Services from "./component/Services";
import Ourprocess from "./component/Ourprocess";
import Whydoggle from "./component/Whydoggle";
import Success from "./component/Success";
import Footer from "../header/Footer";
import Discover from "./component/Discover";
import useScrollAnimation from "../useScrollAnimation";
const Home = () => {
  useScrollAnimation();
  return (
    <>
      <Box fontFamily={"Archivo"} position="relative" zIndex={0}>
        <Hero />
        <WelcomeSection />
        <Whatwedo />
        <Successstories />
        <Discover />
        <Services />
        <Ourprocess />
        <Whydoggle />
        <Success />
      </Box>
      <Footer />
    </>
  );
};

export default Home;
